<template>
  <v-row dense>
    <v-col cols="12">
      <v-text-field
        v-model="value.city"
        :rules="formRules.city"
        :solo-inverted="soloInverted"
        :disabled="disabled"
        :readonly="readonly"
        label="Miasto"
        :class="inputClass"
        @keyup="$emit('changed')"
      >
        <template v-slot:prepend v-if="prependIcons">
          <v-icon v-bind:class="{ 'wastemaster--grey-out-color': greyOutIcons }"
            >mdi-map-marker</v-icon
          >
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="12" md="4">
      <v-text-field
        v-model="value.postalCode"
        v-mask="'##-###'"
        :rules="(formRules.postalCode, formRules.postalCodeRegex)"
        :solo-inverted="soloInverted"
        :disabled="disabled"
        :readonly="readonly"
        label="Kod pocztowy"
        required
        :class="inputClass"
        @keyup="$emit('changed')"
      >
        <template v-slot:prepend v-if="prependIcons">
          <v-icon
            v-bind:class="{
              'address-form--hidden-icon': displayIconForCityOnly
            }"
            >mdi-map-marker</v-icon
          >
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="12" md="8">
      <v-select
        v-model="value.region"
        :items="getAllRegions()"
        item-text="value"
        item-value="key"
        :rules="formRules.region"
        :solo-inverted="soloInverted"
        :disabled="disabled"
        :readonly="readonly"
        label="Województwo"
        required
        :class="inputClass"
        @change="$emit('changed')"
      >
        <template v-slot:prepend v-if="prependIcons">
          <v-icon
            v-bind:class="{
              'address-form--hidden-icon': displayIconForCityOnly
            }"
            >mdi-map-marker</v-icon
          >
        </template>
      </v-select>
    </v-col>
  </v-row>
</template>

<script>
import { mask } from 'vue-the-mask'
import { mapGetters } from 'vuex'

export default {
  name: 'AddressForm',
  directives: {
    mask
  },
  props: {
    value: {
      type: Object,
      default() {
        return {
          city: '',
          postalCode: '',
          region: ''
        }
      }
    },
    soloInverted: {
      type: Boolean,
      default: false
    },
    prependIcons: {
      type: Boolean,
      default: true
    },
    displayIconForCityOnly: {
      type: Boolean,
      default: true
    },
    greyOutIcons: {
      type: Boolean,
      default: true
    },
    allRequired: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    inputClass: {
      type: String,
      required: false
    }
  },
  data() {
    const cityMaxLength = 100
    return {
      formRules: {
        city: [
          (value) => !this.allRequired || !!value || 'Podaj miasto',
          (value) =>
            (value || '').length <= cityMaxLength ||
            `Maksymalna długość pola to ${cityMaxLength} znaków`
        ],
        postalCode: [
          (value) => !this.allRequired || !!value || 'Podaj kod pocztowy'
        ],
        postalCodeRegex: [
          (value) =>
            (!this.allRequired && !value) ||
            (!!value && /^\d{2}-\d{3}$/.test(value)) ||
            'Podaj prawidłowy kod pocztowy'
        ],
        region: [(value) => !this.allRequired || !!value || 'Podaj województwo']
      }
    }
  },
  methods: {
    ...mapGetters(['getAllRegions'])
  }
}
</script>

<style scoped>
.address-form--hidden-icon {
  visibility: hidden;
}
</style>
